import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';

import * as loginActionCreators from '../../../actions/login';
let allActionCreators = Object.assign({}, loginActionCreators);

import {passwordValidation} from '../../../utils/itemValidation';

import TextField from 'material-ui/TextField';


class ResetPassword extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      serverError: null,
      serverSuccess: true,
      requestPending: false,
      password1: '',
      password2: '',
      password1Error: null,
      password2Error: null,
      resetToken: this.props.routeParams.token,
    };
  }

  changePassword1(evt) {
    this.setState({ password1: evt.target.value });
  }

  changePassword2(evt) {
    this.setState({ password2: evt.target.value });
  }

  validatePassword1() {
    let passwordError = passwordValidation(this.state.password1);
    if(passwordError === null && this.state.password1 !== '' && this.state.password2 !== '' && this.state.password1 != this.state.password2) {
      passwordError = 'Passwords must match';
    }
    this.setState({ password1Error: passwordError });
  }

  validatePassword2() {
    let passwordError = passwordValidation(this.state.password2);
    if(passwordError === null && this.state.password1 !== '' && this.state.password2 !== '' && this.state.password1 != this.state.password2) {
      passwordError = 'Passwords must match';
    }
    this.setState({ password1Error: passwordError });
  }

  loginNav() {
    this.context.router.push('/login');
  }

  validateAll() {
    let password1Error = passwordValidation(this.state.password1);
    let password2Error = passwordValidation(this.state.password2);

    this.setState({
      password1Error: password1Error,
      password2Error: password2Error,
    });
    return password1Error === null && password2Error === null;
  }

  handleRequestPassword(evt) {
    evt.preventDefault();
    if(this.validateAll()) {
      this.setState({
      	serverError: null,
      	requestPending: true,
      }, () => {
        let resetData = {
          password: this.state.password1,
          token: this.state.resetToken,
        }
      	this.props.callResetPassword(resetData)
	      .then((respData) => {
	        this.setState({
	        	serverSuccess: true,
	        	requestPending: false,
	        	password1: '',
            password2: '',
	        });
	      })
	      .catch((errorData) => {
	        let errorMessage = errorData.message ? errorData.message : 'Cannot connect to Crash of Rhinos';
	        this.setState({
	        	serverError: errorMessage,
	        	requestPending: false,
	        	password1: '',
            password2: '',
	        });
	      });
      });
    } 
  }

  render() {
    return <div className='ResetPassword'>
      <div className='externalWrapper'>
        <div className='externalTitle'>{this.state.serverSuccess ? 'Success!' : 'Reset Password'}</div>
        {this.state.serverError ? 
        	<div className='externalError'>{this.state.serverError}</div> :
        	null
        }
        {this.state.serverSuccess ? 
        	<div className='forgotSuccess'>
            <div className='successText'>Your password has been successfully changed.</div>
            <div className='ResponsiveForm'>
              <div className='formRow'>
                <div className='inputWrapper'>
                  <button
                    className={'actionButton resetLoginNav'}
                    onClick={::this.loginNav}>
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div> :
        	<div className='ResponsiveForm'>
            <div className='formRow'>
              <div className='inputWrapper'>
                <TextField
                  value={this.state.password1} 
                  onChange={::this.changePassword1} 
                  onBlur={::this.validatePassword1}
                  errorText={this.state.password1Error} 
                  hintText='Password'
                  floatingLabelText='Password'
                  type='password'
                  fullWidth={true} 
                  required />
              </div>
            </div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <TextField
                  value={this.state.password2} 
                  onChange={::this.changePassword2} 
                  onBlur={::this.validatePassword2}
                  errorText={this.state.password2Error} 
                  hintText='Re-Enter Password'
                  floatingLabelText='Re-Enter Password'
                  type='password'
                  fullWidth={true} 
                  required />
              </div>
            </div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <button
                  className={'actionButton resetSubmitButton'}
                  onClick={::this.handleRequestPassword}
                  disabled={this.state.requestPending}>
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>;
  }
}
export default ResetPassword;

function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

export const ResetPasswordContainer = connect(
  mapStateToProps,
  allActionCreators
)(ResetPassword);


// WEBPACK FOOTER //
// ./src/components/views/reset-password/ResetPassword.jsx